
import { Component, OnInit, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MdPaginator, MdSnackBar, MdDialog } from "@angular/material";
import { DataSource } from "@angular/cdk/collections";
import { IncassoListItemModel } from "../../models/incassi/incasso-list-item.model";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { BrogliacciService } from './../../services/brogliacci.service';
import { IncassiService } from "../../services/incassi.service";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { BrogliaccioDistintaModel } from "../../models/brogliacci/brogliaccio-distinta.model";
import { IncassoModel } from "../../models/incassi/incasso.model";
import { IncassoContantiListItemModel } from "../../models/incassi/incasso-contanti-list-item.model";
import { IncassoAssegniListItemModel } from "../../models/incassi/incasso-assegni-list-item.model";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { DistintaContantiDialogConfigModel, DistintaContantiDialog } from "../incassi/distinta-contanti.component";
import { DistintaAssegniDialogConfigModel, DistintaAssegniDialog } from "../incassi/distinta-assegni.component";
import { Configurations } from "../../core/configurations";
import { PartitaListItemModel } from './../../models/incassi/partita-list-item.model';
import { PartiteService } from "../../services/partite.service";
import { AccontoModel } from '../../models/incassi/acconto.model';
import { UltimaVersioneApplicativoClientService } from '../../services/ultima-versione-applicativo-client.service';

@Component({
  selector: 'app-brogliaccio-detail',
  templateUrl: './brogliaccio-detail.component.html',
  styleUrls: ['./brogliaccio-detail.component.css']
})

export class BrogliaccioDetailComponent implements OnInit {
  activatedRoute: any;
  isLoading: boolean;
  //nuovo brogliaccio
  brogliaccioCorrente: BrogliaccioDistintaModel;
  tokenBrogliaccio: string;
  partiteAssegnateDatasource: PartiteDataSource = null;
  accontiDataSource: AccontiDataSource = null;
  displayedColumns = ['idDocumento', 'dataDocumento', 'dataScadenza', 'totaleFattura', 'importoResiduo', 'importoAssegnato','idIncasso'];
  displayedColumnsAcconto = ['codiceAs400', 'nomeAzienda', 'partitaIVA', 'importo','idIncasso'];
  hasContanti: boolean = false;
  hasAssegni: boolean = false;
  hasAcconti: boolean = false;
  constructor(
    private partiteService: PartiteService,
    private configuration: Configurations,
    private _incassiService: IncassiService,
    private _brogliacciService: BrogliacciService,
    private snackBar: MdSnackBar,
    private route: ActivatedRoute,
    private distintaContantiDlg: MdDialog,
    private distintaAssegniDlg: MdDialog,
    private router: Router,
    private _ultimaVersioneClientTipo:UltimaVersioneApplicativoClientService
    ) { }


  ngOnInit() {
    //alert("pagina dettaglio brogliacci");
    this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
    .subscribe(data => {
      Configurations.currentVersionCod=data.codice;
      let v=localStorage.getItem('clientVersion');
      if(v===null||v===undefined||v!==data.codice) {
        localStorage.setItem('clientVersion',data.codice);
        alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
        window.location.href=Configurations.baseUrl;
        
      }
    });
    this.isLoading = true;
    this.route.paramMap
      .switchMap((params: ParamMap) => this._brogliacciService.get(params.get('gid')))
      .subscribe(vv => {
        this.brogliaccioCorrente = vv;
        let main = this;
        if (this.brogliaccioCorrente.incassi != null && this.brogliaccioCorrente.incassi.length > 0) {
          let acconti: AccontoModel[] = [];
          this.brogliaccioCorrente.incassi.map(function (inc) {
            if (inc.accontiIncasso != null && inc.accontiIncasso.length > 0) {
              acconti = acconti.concat(inc.accontiIncasso);
              main.hasAcconti = true;
            }
            if (inc.totaleValuta && inc.totaleValuta > 0) {
              main.hasContanti = true;
            }
            if (inc.totaleAssegni && inc.totaleAssegni > 0) {
              main.hasAssegni = true;
            }

          }

          );
          let partiteDistinta:PartitaListItemModel[]=[];
          vv.incassi.map(function(inc){
            partiteDistinta=partiteDistinta.concat( inc.partiteIncassoViewModel);
          });
          this.partiteAssegnateDatasource=new PartiteDataSource(partiteDistinta);
          main.accontiDataSource = new AccontiDataSource(acconti);
        }
        this.isLoading=false;
        // //estraggo la lista delle partite assegnate
        // if (this.brogliaccioCorrente) {
        //   this.partiteService.getListaPartiteAssegnate(this.brogliaccioCorrente.token)
        //     .finally(() => this.isLoading = false)
        //     .catch((r: Response, o) => {
        //       return Observable.throw(r);
        //     })
        //     .subscribe((r: PartitaListItemModel[]) => {
        //       this.partiteAssegnateDatasource = new PartiteDataSource(r.filter(pI => pI.importoAssegnato && pI.importoAssegnato > 0));
        //     },
        //       error => {
        //         this.showError("Errore durante la procedura di caricamento delle partite");
        //         this.isLoading = false;
        //         return false;
        //       })
        //     ;
        // }

      },
        error => {
          this.showError("Errore durante il caricamento dei dati");
          return false;
        });
  }

  /* TOTALI */
  totaleMonete(listaContanti: IncassoContantiListItemModel[]): number {
    let tot = 0;
    if (!listaContanti) { return 0; }

    listaContanti.forEach(c => {

      if (c.importoTaglio == null && c.importo) {
        tot = tot + c.importo;
      }
    });
    return tot;

  }

  totaleBanconote(listaContanti: IncassoContantiListItemModel[]): number {
    let tot = 0;
    if (!listaContanti) { return 0; }
    listaContanti.forEach(c => {
      if (c.importoTaglio != null && c.importo != null) {
        tot = tot + c.importo;
      }
    });
    return tot;
  }

  /* CONFERMA */
  confermaBrogliaccio(): void {
    this.isLoading = true;
    if (this.brogliaccioCorrente.stato.id !== 1) {
      this.showError("Errore. Il brogliaccio non può essere confermato");
    } else {
      this._brogliacciService.confermaBrogliaccio(this.brogliaccioCorrente)
        .finally(() => this.isLoading = false)
        .subscribe(

          data => {
            this.showInfo("Conferma avvenuta correttamente");
            this.brogliaccioCorrente.stato = new DizionarioModel();
            this.brogliaccioCorrente.stato.id = 2;
          },
          error => {
            this.showError("Errore durante la procedura di conferma del brogliaccio");
            return false;
          });
    }

  }

  /* ELIMINAZIONE DI UN BROGLIACCIO */
  eliminaBrogliaccio() {
    //elimino il brogliaccio (dalla lista) ed esco
    this._brogliacciService.eliminaBrogliaccio(this.brogliaccioCorrente.token).subscribe(
      data => {
        this.showInfo("Eliminazione avvenuta correttamente");
        this.router.navigateByUrl('/brogliacci');
      },
      error => {
        this.showError("Errore durante la procedura di eliminazione del brogliaccio");
        return false;
      }
    );
  }

  /* STAMPA TODO */
  stampaBrogliaccio() {
    //ritorna il pdf 

    let self = this;

    // Status flag used in the template.
    let pending = true;

    // Create the Xhr request object
    let xhr = new XMLHttpRequest();
    let preurl = this.configuration.apiBaseUrlStampe;
    let MethodPrint = "print";
    let url = preurl + MethodPrint + "/" + this.brogliaccioCorrente.token;
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    let scope = this;

    // Xhr callback when we get a result back
    // We are not using arrow function because we need the 'this' context
    xhr.onreadystatechange = function () {

      // We use setTimeout to trigger change detection in Zones
      setTimeout(() => { pending = false; }, 0);
      // If we get an HTTP status OK (200), save the file using fileSaver
      if (xhr.readyState === 4 && xhr.status === 200) {
        let blob = new Blob([this.response], { type: 'application/pdf' });
        //fileSaver.saveAs(blob, 'Report.pdf');
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, "broglaiccio " + scope.brogliaccioCorrente.id + ".pdf");
        } else {
          let urlBlob = window.URL.createObjectURL(blob);
          window.open(urlBlob);
        }
      }
    };

    // Start the Ajax request
    xhr.send();

  }


  /* STAMPA  */
  stampaIncasso(incasso) {
    //ritorna il pdf 

    let self = this;

    // Status flag used in the template.
    let pending = true;

    // Create the Xhr request object
    let xhr = new XMLHttpRequest();
    let preurl = this.configuration.apiBaseUrlStampe;
    let MethodPrint = "printIN";
    let url = preurl + MethodPrint + "/" + incasso.token;
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';

    // Xhr callback when we get a result back
    // We are not using arrow function because we need the 'this' context
    xhr.onreadystatechange = function () {

      // We use setTimeout to trigger change detection in Zones
      setTimeout(() => { pending = false; }, 0);

      // If we get an HTTP status OK (200), save the file using fileSaver
      if (xhr.readyState === 4 && xhr.status === 200) {
        let blob = new Blob([this.response], { type: 'application/pdf' });
        //fileSaver.saveAs(blob, 'Report.pdf');
        let urlBlob = window.URL.createObjectURL(blob);
        window.open(urlBlob);
      }
    };

    // Start the Ajax request
    xhr.send();
  }
  /* APERTURA DETTAGLI */

  openDistintaContanti(incassoCorrente: IncassoModel) {
    let dlgRef = this.distintaContantiDlg.open(DistintaContantiDialog,
      { data: new DistintaContantiDialogConfigModel(incassoCorrente, false) })
      .afterClosed().subscribe((res: IncassoModel) => {

      });
  }

  openDistintaAssegni(incassoCorrente: IncassoModel) {
    let dlgRef = this.distintaAssegniDlg.open(DistintaAssegniDialog,
      { data: new DistintaAssegniDialogConfigModel(incassoCorrente, false), width: '80%' })
      .afterClosed().subscribe((res: IncassoModel) => {
      });
  }

  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 2000 });
  }

}
export class PartiteDataSource extends DataSource<any> {
  partite: Observable<PartitaListItemModel[]> = null;

  constructor(private data: PartitaListItemModel[]) {
    super();
  }
  connect(): Observable<PartitaListItemModel[]> {
    this.partite = Observable.of(this.data);
    return this.partite;
  }
  disconnect(): void { }

}
export class AccontiDataSource extends DataSource<any> {
  acconti: Observable<AccontoModel[]> = null;

  constructor(private data: AccontoModel[]) {
    super();
  }
  connect(): Observable<AccontoModel[]> {

    this.acconti = Observable.of(this.data);
    return this.acconti;
  }
  disconnect(): void { }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/brogliacci/brogliaccio-detail.component.ts